  $(document).ready(function() {
    $('.index_brand_slider').slick({
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2,
              arrows: false,
              dots: false, 
            }
          },
          {
            breakpoint: 641,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: false,
              dots: false,
            }
          },
          {
            breakpoint: 481,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
              dots: false,
            }
          }
        ]
    }); 
    $('.index_customer_care_slider').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: false,
              dots: true, 
            }
          },
          {
            breakpoint: 641,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: false,
              dots: true,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
              dots: true,
            }
          }
        ]
    }); 
    $('.product_brand_slider').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      arrows: false,
      dots: false,
    }); 
    $('.index-review-slider').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
    }); 
    
//     $('.about-columns-images-slider').slick({
//       infinite: false,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       arrows: false,
//       dots: true,
//     }); 
    
      var payment_icon = setInterval(function(){
      if($(".afterpay-paragraph").length > 0){
        jQuery(".afterpay-text1").text("or 4 instalments of ");
    	jQuery(".afterpay-text2").text(" with ");
        clearInterval(payment_icon);
      }
    }, 100);
    
       $(document).on("click",".logo-box",function(e) {
      //$(this).siblings().toggle();
      var tab_id = $(this).attr('data-tab');
       $('.logo-box').removeClass('active');
      $('.index_brand_slider_content .logo-sub-text').removeClass('active');

      $(this).addClass('active');
      $("#"+tab_id).addClass('active');
    });
    
    $(document).on("click",".bundle-img-item",function(e) {
      //$(this).siblings().toggle();
      var tab_id = $(this).attr('data-id');
       $('.bundle-img-item').removeClass('active');
      $('.bundle-product-wrap').removeClass('active');

      $(this).addClass('active');
      $("#"+tab_id).addClass('active');
    });
    
    $(function() {
		 $(".bundle_submit1").click(function(e) {
        	e.preventDefault();
           	//var frmAction = $('.form_bundle_product1').serialize();
           	var bundle_product = $('input[name=bundle_id1]').val();
           	 $.ajax({
               	type: "POST",
                cache: false,
               	url: '/cart/add.js',
                data: { quantity: 1, id: bundle_product },
                async: false,
                xhrFields: { withCredentials: false },
                success: function(result){
               	  window.location.href= "/cart";
               	}
             });
         });
      
      	$(".bundle_submit2").click(function(e) {
        	e.preventDefault();
           	//var frmAction2 = $('.form_bundle_product2').serialize();
           	var bundle_product = $('input[name=bundle_id2]').val();
           	 $.ajax({
               	type: "POST",
                cache: false,
               	url: '/cart/add.js',
                data: { quantity: 1, id: bundle_product },
                async: false,
                xhrFields: { withCredentials: false },
                success: function(result){
               	  window.location.href= "/cart";
               	}
             });
         });
      
      	$(".bundle_submit3").click(function(e) {
        	e.preventDefault();
           	//var frmAction3 = $('.form_bundle_product3').serialize();
           	var bundle_product = $('input[name=bundle_id3]').val();
           	 $.ajax({
               	type: "POST",
                cache: false,
               	url: '/cart/add.js',
                data: { quantity: 1, id: bundle_product },
                async: false,
                xhrFields: { withCredentials: false },
                success: function(result){
               	  window.location.href= "/cart";
               	}
             });
         });
    });

      $('.index-customer-care-team .text-column__button-row .text-column__button').click(function(){
        $('html, body').animate({
          scrollTop: $( $.attr(this, 'href') ).offset().top - 140
        }, 800);
        return false;
      });

    var payment_icon = setInterval(function(){
      
      if($(".afterpay-paragraph").length > 0){
        
        jQuery(".afterpay-text1").text("or 4 instalments of ");
    	jQuery(".afterpay-text2").text(" with ");
        
        clearInterval(payment_icon);

      }

    }, 100);


        $('.toggle-item').click(function(e) {
        e.preventDefault();

        var $this = $(this);

        if ($this.next().hasClass('inner-show')) {
            $this.removeClass('active');
            $this.next().removeClass('inner-show');
            $this.next().slideUp(350); 
        } else { 
            $this.parent().parent().find('li .toggle-item ').removeClass('active');
            $this.toggleClass('active');
            $this.parent().parent().find('li .inner').removeClass('inner-show');
            $this.parent().parent().find('li .inner').slideUp(350); 
            $this.next().toggleClass('inner-show');
            $this.next().slideToggle(350); 
        } 
    });
    
  });

function BannerSliderInstance() {
    let $bannerSlider = $('.banner_slider_slick');
    let $imageTextSlider = $('.image_text_slick');

    // Check if slick is initialized and destroy before reinitializing
    if ($bannerSlider.hasClass('slick-initialized')) {
        $bannerSlider.slick('unslick');
    }

    $bannerSlider.slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        arrows: false,
        dots: false,
        prevArrow: '<div class="slick-arrow-custom slick-prev-custom"><span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><title>Left</title><polyline points="15 18 9 12 15 6"></polyline></svg></span></div>',
        nextArrow: '<div class="slick-arrow-custom slick-next-custom"><span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><title>Right</title><polyline points="9 18 15 12 9 6"></polyline></svg></span></div>',
        responsive: [
            {
                breakpoint: 5000,
                settings: "unslick"
            },
            {
                breakpoint: 992,
                settings: {
                    autoplay: true,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });

    // Initialize Image Text Slider if not already initialized
    if (!$imageTextSlider.hasClass('slick-initialized')) {
        $imageTextSlider.slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            prevArrow: '<div class="slick-arrow-custom slick-prev-custom"><span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><title>Left</title><polyline points="15 18 9 12 15 6"></polyline></svg></span></div>',
            nextArrow: '<div class="slick-arrow-custom slick-next-custom"><span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><title>Right</title><polyline points="9 18 15 12 9 6"></polyline></svg></span></div>',
        });
    }
}

// Call the function once on page load
BannerSliderInstance();

// Debounce function to limit the frequency of resize events
function debounce(func, wait) {
    let timeout;
    return function () {
        const context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}

// Reinitialize slider on window resize with debounce
$(window).on('resize', debounce(function () {
    BannerSliderInstance();
    console.log("BannerSliderInstance reinitialized on resize.");
}, 300));

// CD Arshit
$(document).on('click', '.klaviyo-form-Y63Q8L button.needsclick.go331100717', function(){
  window._fbq.push('track', 'Lead');
});


$('.carousel').each(function () {
  $(this).on('changed.owl.carousel', function(e) {
    const items    = e.item.count;
    const current  = e.item.index;
    const perPage  = e.page.size;

    $(this).closest('.collection-listing').find('.prev').toggleClass('disabled', current === 0);
    $(this).closest('.collection-listing').find('.next').toggleClass('disabled', current >= items - perPage);
  })
});

// document.addEventListener('rebuy.ready', (event) => {
//   const widget = event.detail.widget;
//   const carouselWidgetId = 177883;

//   if (widget.id == carouselWidgetId) {
//     const interval = setInterval(function() {
//       const splideEl = document.querySelector(`[data-rebuy-id="${widget.id}"] .splide.is-initialized`);

//       log
      
//       if (splideEl) {
//         clearInterval(interval);
//         const splide = new Splide(splideEl);

//         splide.destroy();
//         console.log('splide destroyed');
        
//         splide.options = {
//           rewind: false,
//           type: 'slide',
//           perMove: 1
//         };
//         splide.mount();

//         const prevBtn = splideEl.querySelector('.splide__arrow--prev');
//         const nextBtn = splideEl.querySelector('.splide__arrow--next');

//         function updateButtons(index) {
//           const total   = splide.length;
//           const perPage = splide.options.perPage;

//           prevBtn.classList.toggle('disabled', index === 0);
//           nextBtn.classList.toggle('disabled', index >= total - perPage);
//         }

//         splide.on('moved', function(newIndex) {
//           updateButtons(newIndex);
//         });

//         updateButtons(splide.index);
//       }
//     }, 100);
//   }
// });
